<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Function" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                        router-link.btn-default(to="/function") 
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                            span(style="padding-left: 8px;") Back
            //- .box__body
            .box__body.p-4
                .container-form(action="" method="method")
                    section.group-fields.border-b
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="name") Name *
                            .field__form
                                input.field-style(id="name" name="name" type="text" v-model="name" maxlength="255")
                                .error(v-if="error_name !== null") {{ error_name }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="label") Label *
                            .field__form
                                input.field-style(id="label" name="label" type="text" v-model="label" maxlength="255")
                                .error(v-if="error_label !== null") {{ error_label }}

                        .field.mb-4
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="module_id") Module *
                            .field__form
                                .relative
                                    select.field-style(name="module_id" v-model="module_id")
                                        option(value="") - Select Module -
                                        template(v-if="modules_list.data && modules_list.data.length > 0")
                                            option(v-for="(module,index) in modules_list.data" :key="module.id" :value="module.id") {{ module.name }}
                                    .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="description") Description
                            .field__form
                                textarea.field-style(id="description" name="description" v-model="description" style="min-height: 200px;")
                            .error(v-if="error_description !== null") {{ error_description }}

                    .flex.items-center.justify-end
                        button.ml-2.btn-default.btn-large(type='button' @click="reset()")
                            | Reset
                        button.ml-2.btn-primary-o.btn-large(type='submit' @click="submit($event, true)")
                            | Save &amp; Continue
                        button.ml-2.btn-primary.btn-large(type='submit' @click="submit")
                            | Save

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';

export default {
    name: 'PageFunctinForm',
    components: {
        HeaderGlobal,
    },
    data: function() {
        return {
            name: '',
            label: '',
            module_id: '',
            description: '',
            
            // error field
            error_name: '',
            error_label: '',
            error_module_id: '',
            error_description: '',
        };
    },
    computed: {
        ...mapState([
            'load_data_status_function_detail',
            'function_detail',
            'load_data_status_modules_list',
            'modules_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        breadcrumb() {
            let page = {
                name: 'Edit Function',
                url: '/function/'+this.id+'/edit',
            };
            if (this.route_name === 'PageFunctionCreate')
                page = {
                    name: 'Add Function',
                    url: '/function/create',
                };

            return [
                {
                    name: 'Function',
                    url: '/function',
                },
                page,
            ];
        },
        page_title() {
            let title = 'Edit Function';
            if (this.route_name === 'PageFunctionCreate')
                title = 'Add Function';
            return title;
        },
    },
    watch: {
        route_name() {
            this.getData();
        },
        id() {},
        breadcrumb() {},
        page_title() {},
        load_data_status_modules_list(newData) {
            if (newData === 'loading') {
                this.showLoading(true);
            } else {
                this.showLoading(false);
            }
        },
        // form data
        function_detail(newData) {
            this.name = (newData.name ? newData.name : '');
            this.label = (newData.label ? newData.label : '');
            this.module_id = (newData.module && newData.module.id ? newData.module.id : '');
            this.description = (newData.description ? newData.description : '');
        },
        name() {},
        label(newData) {
            if (newData !== '' && newData !== null)
                // this.label = newData.replace(/\s+/g, '-').toLowerCase();
                this.label = newData.replace(/\s+/g, '_').toLowerCase();
        },
        description() {},
    },
    methods: {
        getData() {
            // get client module
            if (this.route_name === 'PageFunctionEdit' || this.route_name === 'PageFunctionCreate')
                // temporary
                this.$store.dispatch('getModulesList', [100, 1]);

            this.name = '';
            this.label = '';
            this.module_id = '';
            this.description = '';

            this.error_name = '';
            this.error_label = '';
            this.error_module_id = '';
            this.error_description = '';

            if (this.route_name === 'PageFunctionEdit') {
                // console.log(this.id);

                // for dispatch get data

                this.showLoading(true);

                this.$store.dispatch('getFunctionDetail', [this.id])
                .then((resp) => {
                    if (resp === 'success') {

                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });

            } else {
                if (this.route_name === 'PageFunctionCreate')
                    this.$store.commit('setFunctionDetail', {});
            }
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    if (this.route_name === 'PageFunctionCreate') {
                        this.name = '';
                        this.label = '';
                        this.module_id = '';
                        this.description = '';

                        this.error_name = '';
                        this.error_label = '';
                        this.error_module_id = '';
                        this.error_description = '';
                    } else {
                        this.getData();
                    }
                }
            });
        },
        submit(e, save_continue=false){
            e.preventDefault();
            // console.log(e);

            this.showLoading(true);

            this.error_name = '';
            this.error_label = '';
            this.error_module_id = '';
            this.error_description = '';

            // validation
            if (this.name.length==0 || this.label.length==0 || this.module_id.length==0) {

                this.error_name = (this.name.length==0 ? 'Field name is required.' : '');
                this.error_label = (this.label.length==0 ? 'Field label is required.' : '');
                this.error_module_id = (this.module_id.length==0 ? 'Field module is required.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Name, label, & module is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.name.length>255 || this.label.length>255) {

                this.error_name = (this.name.length>255 ? 'Field name is not more than 255 characters.' : '');
                this.error_label = (this.label.length>255 ? 'Field label is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Name & label is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            // console.log([this.name, this.label);
            // this.getData();

            if (this.route_name === 'PageFunctionCreate') {

                this.$store.dispatch('getFunctionCreate', [this.name, this.label, this.module_id, this.description])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageFunctionIndex' });
                        if (save_continue === false) {
                            this.$router.push('/function');
                        } else {
                            this.$router.push('/function/'+ resp.data.data.id +'/edit');
                        }

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                    } else {
                        
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            this.error_module_id = (resp.data.message.errors.module_id ? resp.data.message.errors.module_id : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });

            // PageFunctionEdit
            } else {

                this.$store.dispatch('getFunctionUpdate', [this.id, this.name, this.label, this.module_id, this.description])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageFunctionIndex' });
                        if (save_continue === false)
                            this.$router.push('/function');

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {

                        if (resp.data.message && resp.data.message.errors) {
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            this.error_module_id = (resp.data.message.errors.module_id ? resp.data.message.errors.module_id : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        this.getData();
    },
   
}
</script>

<style lang="sass">


</style>
